import { j as e } from "../../_virtual/jsx-runtime.js";
const o = ({
  width: t = 20,
  height: C = 20,
  viewBox: L = "0 0 20 20",
  fill: s = "currentColor",
  ...d
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    width: t,
    height: C,
    viewBox: L,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...d,
    children: [
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M17.8196 16.6592L16.6589 17.8199L2.03558 3.19659L3.19628 2.03589L17.8196 16.6592Z",
          fill: s
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M10.1064 6.62472C11.5324 6.6695 12.7325 7.60986 13.163 8.90196L14.7446 8.3748C14.0828 6.3885 12.2086 4.95638 9.99984 4.95638C9.52429 4.95638 9.06425 5.02277 8.62847 5.14679L10.1064 6.62472Z",
          fill: s
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M7.32828 3.84659C8.14619 3.48844 9.04981 3.28971 9.99984 3.28971C12.9448 3.28971 15.4438 5.1992 16.3262 7.84762L17.9078 7.32043C16.8048 4.00991 13.6811 1.62305 9.99984 1.62305C8.58342 1.62305 7.24953 1.97643 6.08154 2.59985L7.32828 3.84659Z",
          fill: s
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M4.69207 3.53178L5.87721 4.71693C4.86509 5.51442 4.08966 6.59888 3.6736 7.84762L2.09204 7.32043C2.59073 5.82366 3.50248 4.5157 4.69207 3.53178Z",
          fill: s
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M7.06685 5.90657L8.26799 7.10771C7.60097 7.5141 7.08789 8.14818 6.83675 8.90196L5.25517 8.3748C5.58865 7.37389 6.22999 6.5137 7.06685 5.90657Z",
          fill: s
        }
      ),
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.6139 10.4536H7.55706C7.09682 10.4536 6.72373 10.8267 6.72373 11.2869V16.4564C6.72373 16.9166 7.09682 17.2897 7.55706 17.2897H12.557C13.0173 17.2897 13.3904 16.9166 13.3904 16.4564V12.2301L11.6139 10.4536ZM8.3904 15.623V12.1203H11.7237V15.623H8.3904Z",
          fill: s
        }
      )
    ]
  }
);
export {
  o as default
};
